export default __webpack_public_path__ + "static/media/617330ebe77124584e3c45c3289e3c72.ico";